var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfTableRow',{class:['order-summary', { 'order-summary--bold': _vm.bold }]},[_c('SfTableData',{staticClass:"order-summary__spacer"}),_vm._v(" "),_c('SfTableData',[_vm._t("label")],2),_vm._v(" "),_c('SfTableData',[_vm._t("value")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }